import { addBinParcel } from '~/parcels/index.js';
import { LitEntity, html } from '../js/utility/lit-entity';
import './parcel-loader';

class AddBinDialog extends LitEntity {
  render() {
    const passThroughProperties = {
      href: this.href,
    };

    return html`
      <parcel-loader
        .parcel=${addBinParcel}
        .passThroughProperties=${passThroughProperties}
      ></parcel-loader>
    `;
  }
}

window.customElements.define('add-bin-dialog', AddBinDialog);
